import {
  type CompanyResponse,
  type Company,
  type CompanyStats,
  type PaginatedResponse,
} from "@/types/company.type";
import { api } from "./api";
import { AxiosError } from "axios";

// Récupère toutes les entreprises (@)
// export const getCompanies = async (): Promise<Company[]> => {
//   try {
//     const response = await api.get<CompaniesResponse>("/companies");
//     return response.data.companies;
//   } catch (error: any) {
//     throw new Error(
//       error.response?.data?.message ||
//         "Erreur lors de la récupération des entreprises"
//     );
//   }
// };

export const getCompanies = async (params?: {
  page?: number;
  limit?: number;
  search?: string;
  isActive?: boolean;
  companyId?: string;
}): Promise<PaginatedResponse<Company>> => {
  try {
    const queryParams = new URLSearchParams();

    if (params?.page) queryParams.append("page", params.page.toString()); //
    if (params?.limit) queryParams.append("limit", params.limit.toString());
    if (params?.search) queryParams.append("search", params.search);
    if (params?.isActive !== undefined)
      queryParams.append("isActive", params.isActive.toString());

    const response = await api.get<PaginatedResponse<Company>>(
      `/companies?${queryParams}`
    );
    return response.data;
  } catch (error: unknown) {
    if (error instanceof AxiosError) {
      throw new Error(
        error.response?.data?.message ||
        "Erreur lors de la récupération des entreprises"
      );
    }
    throw new Error("Erreur lors de la récupération des entreprises");
  }
};

// Récupère une entreprise par son ID (@GET /companies/{id})
export const getCompanyById = async (
  id: string
): Promise<{ company: Company; stats: CompanyStats }> => {
  try {
    const response = await api.get<CompanyResponse>(`/companies/${id}`);
    return response.data;
  } catch (error: unknown) {
    if (error instanceof AxiosError) {
      throw new Error(
        error.response?.data?.message ||
        "Erreur lors de la récupération de l'entreprise"
      );
    }
    throw new Error("Erreur lors de la récupération de l'entreprise");
  }
};

// Créer une entreprise
export const createCompany = async (data: {
  name: string;
  email: string;
  siret?: string;
}): Promise<Company> => {
  try {
    const response = await api.post<CompanyResponse>("/companies", data);
    return response.data.company;
  } catch (error: unknown) {
    if (error instanceof AxiosError) {
      throw new Error(
        error.response?.data?.message ||
        "Erreur lors de la création de l'entreprise"
      );
    }
    throw new Error("Erreur lors de la création de l'entreprise");
  }
};

// Mettre à jour une entreprise (PATCH /companies/:id)
// @param id: string - L'ID de l'entreprise à mettre à jour
// @param data: {
//   name?: string;
//   email?: string;
//   siret?: string;
//   isActive?: boolean;
// } - Les données à mettre à jour
// @returns Promise<Company> - La entreprise mise à jour
export const updateCompany = async (
  id: string,
  data: {
    name?: string;
    email?: string;
    siret?: string;
    isActive?: boolean;
    pointeuseShowSessions?: boolean;
    pointeuseLogin?: string;
    pointeusePassword?: string;
  }
): Promise<Company> => {
  try {
    const response = await api.patch<CompanyResponse>(`/companies/${id}`, data);
    return response.data.company;
  } catch (error: unknown) {
    // Si l'erreur est une erreur Axios, on throw une nouvelle erreur avec le message de l'erreur Axios
    if (error instanceof AxiosError) {
      throw new Error(
        error.response?.data?.message ||
        "Erreur lors de la mise à jour de l'entreprise"
      );
    }
    // Sinon on throw une nouvelle erreur avec le message "Erreur lors de la mise à jour de l'entreprise"
    throw new Error("Erreur lors de la mise à jour de l'entreprise");
  }
};

// Supprimer une entreprise (DELETE /companies/:id)
export const deleteCompany = async (id: string) => {
  try {
    await api.delete(`/companies/${id}`);
  } catch (error: unknown) {
    if (error instanceof AxiosError) {
      throw new Error(
        error.response?.data?.message ||
        "Erreur lors de la suppression de l'entreprise"
      );
    }
    throw new Error("Erreur lors de la suppression de l'entreprise");
  }
};
